import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import HiddenInput from "atoms/HiddenInput";
import { AddressInputs } from "organisms";
import { ContactInfoFieldsType } from "pages/SharedRecords.types";
import { email, InputProps, required, TextInput, useTranslate } from "react-admin";

import FormGridContainer from "../atoms/Forms/FormGridContainer";

type ContactInfoInputsPropsType = Partial<InputProps> & {
  contactInfoType: string;
  headline?: string;
  inCreate?: boolean;
  omitFields?: ContactInfoFieldsType[];
  requiredFields?: ContactInfoFieldsType[];
};

export default function ContactInfoInputs(props: ContactInfoInputsPropsType) {
  const { contactInfoType, headline, inCreate = false, omitFields = [], requiredFields = [], ...rest } = props;
  const labelPrefix = "resources.users.fields.contact_info";
  const sourcePrefix = contactInfoType ? `${contactInfoType}.` : "";
  const translate = useTranslate();

  return (
    <FormGridContainer>
      {headline && (
        <Grid item xs={12}>
          <Typography variant="body1" component="h3" gutterBottom>
            {translate(headline)}
          </Typography>
        </Grid>
      )}

      {!omitFields.includes("organization_name") && (
        <Grid item xs={12}>
          <TextInput
            {...rest}
            label={`${labelPrefix}.organization_name`}
            source={`${sourcePrefix}organization_name`}
            fullWidth
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <AddressInputs
          sourcePrefix={sourcePrefix}
          omitFields={omitFields}
          requiredFields={requiredFields}
          {...rest}
          inCreate={inCreate}
        />
      </Grid>

      <HiddenInput {...rest} source={`${contactInfoType}.id`} />

      {!omitFields.includes("email") && (
        <Grid item xs={12} md={6}>
          <TextInput
            {...rest}
            label={`${labelPrefix}.email`}
            source={`${sourcePrefix}email`}
            validate={requiredFields.includes("email") ? [required(), email()] : email()}
            fullWidth
          />
        </Grid>
      )}

      {!omitFields.includes("phone") && (
        <Grid item xs={12} md={6}>
          <TextInput {...rest} label={`${labelPrefix}.phone`} source={`${sourcePrefix}phone`} fullWidth />
        </Grid>
      )}

      {!omitFields.includes("mobile") && (
        <Grid item xs={12} md={6}>
          <TextInput
            {...rest}
            variant="outlined"
            label={`${labelPrefix}.mobile`}
            source={`${sourcePrefix}mobile`}
            fullWidth
          />
        </Grid>
      )}
      {!omitFields.includes("fax") && (
        <Grid item xs={12} md={6}>
          <TextInput
            {...rest}
            variant="outlined"
            label={`${labelPrefix}.fax`}
            source={`${sourcePrefix}fax`}
            fullWidth
          />
        </Grid>
      )}
      {!omitFields.includes("website") && (
        <Grid item xs={12} md={6}>
          <TextInput
            {...rest}
            variant="outlined"
            label={`${labelPrefix}.website`}
            source={`${sourcePrefix}website`}
            fullWidth
          />
        </Grid>
      )}
    </FormGridContainer>
  );
}
